export const ALL_DATA_TYPES = {
  number: 'number',
  string: 'string',
  boolean: 'boolean',
  dropdown: 'dropdown',
  multi_select: 'multi_select',
  reference_user: 'reference_user',
  reference_lead_stage: 'reference_lead_stage',
  reference_lead_source: 'reference_lead_source',
  datetime: 'datetime',
  date: 'date',
  activity_note: 'ActivityNote',
  default: 'default',
} as const;

export const DATA_TYPES_WITH_OPTIONS: string[] = [
  ALL_DATA_TYPES.dropdown,
  ALL_DATA_TYPES.multi_select,
  ALL_DATA_TYPES.reference_user,
  ALL_DATA_TYPES.default,
] as const;

export type DataTypeType = typeof ALL_DATA_TYPES[keyof typeof ALL_DATA_TYPES];

export const DATA_TYPES_TO_READABLE_NAME = {
  ...Object.values(ALL_DATA_TYPES).reduce((acc, value) => ({ ...acc, [value]: value }), {}),
  [ALL_DATA_TYPES.dropdown]: 'Dropdown',
  [ALL_DATA_TYPES.multi_select]: 'Multi-Select',
  [ALL_DATA_TYPES.reference_user]: 'User Type',
  [ALL_DATA_TYPES.reference_lead_stage]: 'Lead Stage',
  [ALL_DATA_TYPES.reference_lead_source]: 'Lead Source',
} as Record<DataTypeType, string>;
